<template>
    <footer class="page-footer grey darken-3">
        <div class="container">
            <div class="row center">
                <div class="col s12 l12">
                    <h5>Sobre Nosotros</h5>
                    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aperiam fugiat vel quia impedit, repellat ducimus unde possimus deleniti rerum praesentium, eos officiis adipisci libero perferendis aliquid sunt, facilis laboriosam accusamus!</p>
                    <a href="#" class="btn-floating btn-small indigo darken-3 social">
                        <i class="fab fa-facebook"></i>
                    </a>
                    <a href="#" class="btn-floating btn-small indigo darken-3 social">
                        <i class="fab fa-instagram"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="footer-copyright grey darken-4">
            <div class="container center-align">&copy; 2020 Movimiento Alpha</div>
        </div>
    </footer>
</template>

<script>
export default { }
</script>

<style scoped>
    .social {
        margin: 0 5px 0 5px;
    }

    .page-footer {
        padding-bottom: .5px;
    }
</style>